import React from "react";
import { FiltersTypes } from "../../../common/types/filters/general";

interface RulesStatusFilterLabelProps {
    filters: Pick<FiltersTypes, "rulesEnabledOnly">;
}

export const RulesStatusFilterLabel: React.FC<RulesStatusFilterLabelProps> = ({
    filters: { rulesEnabledOnly },
}) => <>{rulesEnabledOnly === true ? "Enabled" : "All"}</>;
